import { AccountControls } from "../../account/kit";
import styles from "./AccountControls.module.css";

export default AccountControls;

/** The same controls alone in a page's top-right corner, for a page with no header (the home page, the resume). */
export function AccountCorner() {
  return (
    <div className={styles.corner}>
      <AccountControls />
    </div>
  );
}
